var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongKongxian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tongyong_kongxian_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4h1.2a2 2 0 110 4H12V4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4V3h-1v1h1zm0 4h-1v1h1V8zm0-3h1.2V3H12v2zm1.2 2H12v2h1.2V7zM13 8V4h-2v4h2zm1.2-2a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1-1a1 1 0 011 1h2a3 3 0 00-3-3v2z",
    fill: "#3F465C",
    mask: "url(#tongyong_kongxian_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.57 4.5h.5V4h-.5v.5zM3.331 5h9.239V4H3.331v1zm8.739-.5v2.495h1V4.5h-1zM3.4 6.995V4.931h-1v2.064h1zm4.335 4.335A4.335 4.335 0 013.4 6.995h-1a5.335 5.335 0 005.335 5.335v-1zm4.335-4.335a4.335 4.335 0 01-4.335 4.335v1a5.335 5.335 0 005.335-5.335h-1zM3.331 4a.931.931 0 00-.931.931h1c0 .038-.03.069-.069.069V4z",
    fill: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 1.92v.96M8.066 1.92v.96M11.4 1.92v.96M2.613 14h10.4",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_kongxian.4155cfb4.svg";
export { SvgTongyongKongxian as ReactComponent };